<template lang="pug">
modal(v-if="cliente", :max-width="1200")
  .card.text-left
    .card-header.bg-info.text-white
      span.fa.fa-info-circle.mr-2
      | {{ cliente.cliente || 'Nuevo cliente' }}
      button.close(@click="cerrar") &times;
    .card-body.bg-light(
      style="border-bottom:1px solid #e0e0e0;box-shadow:0 2px 2px rgba(0,0,0,0.1);"
    )
      .row
        .col-xs-12.col-sm-6.col-md-4.col-lg-3(style="margin-bottom:15px;")
          .input-group.input-group-sm.has-error(v-if="!cliente.agente.ID")
            .input-group-prepend
              span.input-group-text Agente
              input-query(
                input-class="form-control-sm form-control",
                :realtime="true",
                url="gestion-clientes/php/api/buscaAgente.php",
                placeholder="Selecciona el agente",
                @selected="setAgente($event)"
              )
          ul.capaAgente(v-if="cliente.agente.ID")
            li
              img(
                :src="cliente.agente.avatar",
                alt="",
                style="width:50px;height:50px;border-radius:25px;"
              )
            li
              b Agente:
              br
              | {{ cliente.agente.nombre }}
              span.ml-2.text-danger(
                style="cursor:pointer;text-decoration:underline;",
                @click="setAgente(null)",
                v-if="permisoEditar"
              ) (Cambiar)
        .col-xs-12.col-sm-6.col-md-8.col-lg-9
          .input-group.input-group-sm(
            :class="!cliente.cliente ? 'has-error' : 'has-success'"
          )
            .input-group-prepend
              span.input-group-text Nombre Fiscal
            input.form-control(
              type="text",
              v-model="cliente.cliente",
              placeholder="Nombre del cliente",
              :disabled="!permisoEditar"
            )
            .input-group-prepend.input-group-append
              span.input-group-text Nombre Comercial
            input.form-control(
              type="text",
              v-model="cliente.nombre_comercial",
              :disabled="!permisoEditar"
            )
          .input-group.input-group-sm.mt-2
            .input-group-prepend
              span.input-group-text CIF
            input.form-control(
              type="text",
              v-model="cliente.CIF",
              placeholder="X12345678",
              :disabled="!permisoEditar"
            )
    ul.nav.nav-tabs.mt-2.ml-1.mr-1
      li.nav-items
        a.nav-link(
          @click="seccion = 'contacto'",
          :class="seccion === 'contacto' ? 'active' : ''"
        ) Contacto
      li.nav-items
        a.nav-link(
          @click="seccion = 'facturacion'",
          :class="seccion === 'facturacion' ? 'active' : ''"
        ) Datos bancarios
      li.nav-items
        a.nav-link(
          @click="seccion = 'bitacora'",
          :class="seccion === 'bitacora' ? 'active' : ''"
        ) Bitácora
    DatosFacturacion(
      v-if="seccion === 'facturacion'",
      :cliente="cliente",
      :formasPago="formasPago",
      :permisoEditar="permisoEditar"
    )
    DatosContacto(
      v-if="seccion === 'contacto'",
      :cliente="cliente",
      :permisoEditar="permisoEditar"
    )
    Bitacora(v-if="seccion === 'bitacora'", :cliente="cliente")

    .card-footer(v-if="permisoEditar")
      .row
        .col
          button.btn.btn-primary.btn-sm(
            @click="guardar",
            :disabled="!clienteCorrecto"
          )
            span.fa.fa-save.mr-2
            | Guardar
          span.ml-3.text-danger(v-if="!clienteCorrecto") <b>Error:</b> {{ error }}
        .col.text-right
          button.mr-1.btn.btn-sm.btn-success(
            v-if="cliente.ID && cliente.comercial",
            @click="liberar()"
          )
            span.fa.fa-trash.mr-2
            | Liberar
          button.mr-1.btn.btn-sm.btn-warning(
            v-if="cliente.ID",
            @click="cerrado()"
          )
            span(v-if="cliente.activo")
              span.fa.fa-trash.mr-2
              span Ha cerrado
            span(v-else)
              span.fa.fa-check.mr-2
              span Ha reabierto
          button.btn.btn-sm.btn-danger(v-if="cliente.ID", @click="eliminar()")
            span.fa.fa-trash.mr-2
            | Eliminar
</template>

<script>
import DatosFacturacion from './datos-facturacion'
import DatosContacto from './contacto'
import Bitacora from './bitacora'
import { mapGetters } from 'vuex'
import API from '../../services/api'

export default {
	name: 'editor-cliente',
	props: ['idCliente'],
	components: {
		DatosContacto,
		DatosFacturacion,
		Bitacora
	},
	watch: {
		idCliente: function (val) {
			if (val === 'nuevo') {
				// Generamos un nuevo objeto de tipo cliente
				this.nuevo()
			} else {
				// Cargamos el cliente
				this.$http
					.get('get-cliente.php?ID=' + val)
					.then((res) => {
						this.cliente = res.data.cliente
					})
					.catch((e) => {
						console.error(e)
					})
			}
		}
	},

	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		}),
		permisoEditar () {
			return (
				this.cliente.ID === null ||
        this.cliente.agente.ID === this.usuario.ID ||
        this.permisos.clientes_crearTodos
			)
		},
		clienteCorrecto () {
			if (!this.cliente.cliente) {
				this.error = 'Debes poner un nombre al cliente'
				return false
			}

			if (!this.cliente.nombre) {
				this.error = 'Debes asignar una persona de contacto en el cliente'
				return false
			}

			if (!this.cliente.place_id) {
				this.error = 'Debes asignar la dirección del cliente'
				return false
			}

			return true
		}
	},

	created () {
		if (this.idCliente === 'nuevo') {
			// Generamos un nuevo objeto de tipo cliente
			this.nuevo()
		} else {
			// Cargamos el cliente
			this.getCliente(this.idCliente)
		}

		// Obtenemos las formas de pago
		API.getFormasPago()
			.then((res) => {
				this.formasPago = res.data.formas
			})
			.catch((e) => {
				console.error(e)
			})
	},

	data: function () {
		return {
			error: null,
			seccion: 'contacto',
			cliente: {
				ID: null,
				nombre: '',
				agente: {
					ID: null,
					nombre: null,
					avatar: null
				},
				CIF: null,
				telefonos: [],
				emails: [],
				direccion: {
					pais: 'España',
					region: 'Comunidad Valenciana',
					provincia: 'Castellón',
					via: null,
					numero: null,
					esc: null,
					piso: null,
					puerta: null,
					cp: null,
					anotaciones: null
				},
				facturacion: {
					forma_de_pago_ID: null,
					tipoCuenta: 'iban',
					cuenta: null
				},
				anotaciones: null
			},
			formasPago: []
		}
	},
	methods: {
		getCliente (ClienteID) {
			API.getCliente(ClienteID)
				.then((res) => {
					this.cliente = res.data.cliente
				})
				.catch((e) => {
					console.error(e)
				})
		},
		nuevo () {
			this.cliente = {
				ID: null,
				nombre: '',
				place_id: null,
				agente: {
					ID: null,
					nombre: null,
					avatar: null
				},
				CIF: null,
				telefonos: [],
				emails: [],
				direccion: {
					pais: 'España',
					region: 'Comunidad Valenciana',
					provincia: 'Castellón',
					via: null,
					numero: null,
					esc: null,
					piso: null,
					puerta: null,
					cp: null,
					indicaciones: null,
					direccion_formateada: null
				},
				facturacion: {
					forma_de_pago_ID: null,
					tipoCuenta: 'iban',
					cuenta: null
				},
				anotaciones: null
			}

			if (!this.permisos.clientes_crearTodos) {
				this.cliente.agente.ID = this.usuario.ID
				this.cliente.agente.nombre = this.usuario.nombre
				this.cliente.agente.avatar = this.usuario.avatar
			}
		},

		setAgente (datos) {
			if (!this.permisos.clientes_crearTodos) {
				return
			}
			if (!datos) {
				this.cliente.agente.ID = null
				this.cliente.agente.nombre = null
				this.cliente.agente.avatar = null
			} else {
				this.cliente.agente.ID = datos.datos.ID
				this.cliente.agente.nombre = datos.datos.nombre
				this.cliente.agente.avatar = datos.datos.avatar
			}
		},

		guardar () {
			if (!this.cliente.cliente) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Por favor escribe el nombre del cliente'
				})
				return
			}

			API.setCliente(this.cliente)
				.then((res) => {
					this.$store.commit('alertas/alert', {
						titulo: 'Guardado',
						mensaje: 'Cliente guardado correctamente'
					})
					this.getCliente(res.data.cliente.ID)
				})
				.catch((e) => {
					this.$store.commit('alertas/alert', {
						title: 'Error',
						mensaje: 'Error guardando los cambios'
					})
				})
		},

		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar cliente',
				mensaje:
          '¿Estás seguro de que quieres eliminar este cliente?\n\nEsta acción no se podrá deshacer',
				callback: (acepta) => {
					if (!acepta) {
						return
					}

					API.eliminar(this.cliente.ID)
						.then((res) => {
							this.$store.commit('alertas/alert', {
								titulo: 'Cliente eliminado',
								mensaje: 'Se ha eliminado el cliente correctamente'
							})
							this.cerrar()
						})
						.catch((e) => {
							this.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							})
						})
				}
			})
		},

		liberar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Liberar cliente',
				mensaje: 'Vas a liberar este cliente desasignándolo del agente',
				callback: (acepta) => {
					if (acepta) {
						API.liberar(this.cliente.ID)
							.then(() => {
								this.$store.commit('toast/success', {
									titulo: 'Cliente liberado'
								})
								this.cerrar()
							})
							.catch((e) => {
								this.$store.commit('alertas/alert', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		cerrado () {
			this.$store.commit('alertas/confirm', {
				titulo: '¿Cerrar cliente?',
				mensaje: `Vas a marcar este cliente como ${
					this.cliente.activo ? 'cerrado' : 'abierto'
				}`,
				callback: (acepta) => {
					if (acepta) {
						const abierto = this.cliente.activo === 1 ? 0 : 1
						API.cerrado(this.cliente.ID, abierto)
							.then(() => {
								this.$store.commit('toast/success', {
									titulo: 'Cliente cerrado'
								})
								this.cerrar()
							})
							.catch((e) => {
								this.$store.commit('alertas/alert', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		cerrar () {
			this.nuevo()
			this.$emit('cerrar')
		}
	}
}
</script>


<style>
.capaAgente {
  display: flex;
  position: relative;
  width: 100%;
  flex-flow: row;
  align-content: center;
  align-items: center;
  align-self: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
}

.capaAgente > li {
  margin: 0;
  padding: 0;
  align-self: center;
  list-style: none;
}
li.nav-items {
  cursor: pointer;
}
#map {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/editor/editor.vue